import * as _ from 'lodash';
import { MediaItemTypes } from '../types/content';
export function normalizeMedia(media) {
    if (media.mediaType === MediaItemTypes.Shape) {
        media = normalizeShape(media);
    }
    else if (media.mediaType === MediaItemTypes.Video) {
        media = normalizeVideo(media);
    }
    else if (media.mediaType === MediaItemTypes.ExtVideo) {
        media = normalizeExtVideo(media);
    }
    else if (media.mediaType === MediaItemTypes.Image) {
        media = normalizeImage(media);
    }
    _.isEmpty(media.Link) && delete media.Link; // remove empty links
    return ('pickBy' in _ ? _.pickBy : _.pick)(media, _.identity); // remove all falsey values from object (null/undefined/false)
}
export function trimAllStringsInObject(obj, visited) {
    if (visited === void 0) { visited = new Set(); }
    if (!_.isArray(obj) && !_.isPlainObject(obj)) {
        return obj;
    }
    if (visited.has(obj)) {
        return obj;
    }
    visited.add(obj);
    _.forEach(obj, function (value, key) {
        if (_.isString(value)) {
            obj[key] = value.trim();
        }
        else if (_.isArray(value) || _.isPlainObject(value)) {
            trimAllStringsInObject(value, visited);
        }
    });
    return obj;
}
var listPartRegex = /\w+(_listHeader|_listFooter)/;
export function normalizeSectionId(id) {
    if (listPartRegex.test(id)) {
        var idx = id.indexOf('_list');
        if (idx !== -1) {
            id =
                id.substr(0, idx + 1) + id[idx + 1].toUpperCase() + id.substr(idx + 2);
        }
    }
    return id.trim();
}
export function normalizeText(text) {
    var cleanText = text
        .replace(/^\s+|\s+$/g, '')
        .replace(/</g, '_')
        .replace(/>/g, '_')
        .replace(/\{\{(\w|\s|^\.)*}}/g, normalizeToken);
    return cleanText ? cleanText : 'no-text';
}
function normalizeToken(expression) {
    // strip expression braces
    var token = expression.replace('{{', '').replace('}}', '').trim();
    // add quotes if needed
    if (token.indexOf(' ') !== -1) {
        token = "'" + token + "'";
    }
    return token ? "{{" + token + "}}" : '';
}
function normalizeShape(shape) {
    if (shape.fileUrl) {
        shape.relativeUri = shape.fileUrl;
    }
    shape.relativeUri = (shape.relativeUri || '').replace(/\.js$/, '.svg');
    if (shape.relativeUri && !shape.relativeUri.startsWith('shapes/')) {
        shape.relativeUri = "shapes/" + shape.relativeUri;
    }
    return shape;
}
function getVideoUri(video) {
    return video.fileName ? video.fileName : video.relativeUri;
}
function normalizeVideo(video) {
    video.relativeUri = getVideoUri(video);
    video.fileOutput = video.fileOutput || buildWixVideoFileOutput(video);
    video.fileInput = video.fileInput || buildWixVideoFileInput(video);
    video.thumbnailUrl = video.thumbnailUrl || buildWixVideoThumbnail(video);
    video.fileBaseUrl = video.fileBaseUrl || buildWixVideoFileBaseUrl(video);
    return {
        Title: video.Title || video.title,
        fileBaseUrl: video.fileBaseUrl,
        fileInput: {
            duration: video.fileInput.duration,
        },
        fileOutput: {
            image: _.map(video.fileOutput.image, function (img) {
                return _.pick(img, ['url', 'width', 'height']);
            }),
            video: _.map(video.fileOutput.video, function (v) {
                return _.pick(v, ['url', 'quality', 'width', 'height', 'format']);
            }),
        },
        mediaType: video.mediaType,
        relativeUri: video.relativeUri,
        thumbnailUrl: video.thumbnailUrl,
        active: video.active,
        locales: video.locales,
        geo: video.geo,
    };
}
function normalizeExtVideo(video) {
    return {
        mediaType: video.mediaType,
        videoUrl: video.videoUrl,
        playmode: video.playmode,
        controls: video.controls,
        locales: video.locales,
        geo: video.geo,
    };
}
function normalizeImage(image) {
    var newImage = {
        id: image.id,
        Title: image.Title || image.title,
        Description: image.Description,
        Link: image.Link,
        crop: image.crop,
        active: image.active,
        fileInput: image.fileInput,
        fileUrl: image.fileUrl,
        uri: image.uri,
        height: image.height,
        width: image.width,
        mediaType: image.mediaType,
        relativeUri: image.relativeUri,
        locales: image.locales,
        geo: image.geo,
        tagsEn: image.tagsEn,
        systemTags: image.systemTags,
    };
    return newImage;
}
function buildWixVideoThumbnail(video) {
    if (video.posters && video.posters.length > 0) {
        return "https://static.wixstatic.com/media/" + video.posters[0].uri + "_srz_p_100_70_75_22_0.50_1.20_0.00_jpg_srz";
    }
    var uri = video.relativeUri;
    return "https://static.wixstatic.com/media/" + uri + "f002.jpg/v1/fit/w_288,h_155/" + uri + "f002.jpg";
}
function buildWixVideoFileBaseUrl(video) {
    var uri = video.relativeUri;
    return "video/" + uri;
}
function buildWixVideoFileInput(video) {
    return {
        audioBitrate: video.audioBitrate / 1000,
        videoBitrate: video.videoBitrate / 1000,
        height: video.height,
        width: video.width,
        fps: video.fps,
        duration: video.duration,
        type: 'video',
        displayAspectRatio: video.displayAspectRatio,
    };
}
function buildWixVideoFileOutput(video) {
    var width = video.width;
    var height = video.height;
    var uri = video.relativeUri;
    return {
        image: _.range(4).map(function (i) { return ({
            url: "media/" + uri + "f00" + i + ".jpg",
            height: height,
            width: width,
        }); }),
        video: [
            {
                format: 'mp4',
                url: "video/" + uri + "/480p/mp4/file.mp4",
                height: 480,
                quality: '480p',
                width: Math.round((width * 480) / height),
            },
            {
                format: 'webm',
                url: "video/" + uri + "/480p/webm/file.webm",
                height: 480,
                quality: '480p',
                width: Math.round((width * 480) / height),
            },
            {
                format: 'mp4',
                url: "video/" + uri + "/720p/mp4/file.mp4",
                height: 720,
                quality: '720p',
                width: Math.round((width * 720) / height),
            },
            {
                format: 'webm',
                url: "video/" + uri + "/720p/webm/file.webm",
                height: 720,
                quality: '720p',
                width: Math.round((width * 720) / height),
            },
            {
                format: 'mp4',
                url: "video/" + uri + "/1080p/mp4/file.mp4",
                height: 1080,
                quality: '1080p',
                width: Math.round((width * 1080) / height),
            },
            {
                format: 'webm',
                url: "video/" + uri + "/1080p/webm/file.webm",
                height: 1080,
                quality: '1080p',
                width: Math.round((width * 1080) / height),
            },
        ],
    };
}
//# sourceMappingURL=contentNormalizer.js.map